import request from "@/utils/request";
const PaymentbaseUrl = `${process.env.VUE_APP_PAYMENT_GATEWAY_BASEURL}/api/v1/admin/txn`;
const PartnerbaseUrl = `${process.env.VUE_APP_PAYMENT_GATEWAY_BASEURL}/api/v1/partner`;
const domesticbaseUrl = `${process.env.VUE_APP_PAYMENT_GATEWAY_BASEURL}/api/v1/domestic`;
export default {
  getTransPartnerStatus(transpinNumber) {
    return request({
      url: `${PaymentbaseUrl}/txn-prt-details?pin_number=${transpinNumber}`,
      method: "GET",
    });
  },
  getTxnDetails(id) {
    return request({
      url: `${PaymentbaseUrl}/get-txn-details?txn_id=${id}`,
      method: "GET",
    });
  },
  getHoldTxnDetails(txn) {
    return request({
      url: `${PaymentbaseUrl}/get-hold-txns?today=${txn}`,
      method: "POST",
    });
  },
  getTransitionDetails(params) {
    return request({
      url: `${PaymentbaseUrl}/summery`,
      method: "GET",
      params,
    });
  },
  getTransitionHistory(transID, login_id, params) {
    return request({
      url: `${PaymentbaseUrl}/history?transaction_id=${transID}&login_id=${login_id}`,
      method: "GET",
      params,
    });
  },
  getRecentTransition(customer_id) {
    return request({
      url: `${PaymentbaseUrl}/recent-transactions-summery?customer_id=${customer_id}`,
      method: "GET",
    });
  },
  getTransitionById(transID, customer_id) {
    return request({
      url: `${PaymentbaseUrl}/history?transaction_id=${transID}&customer_id=${customer_id}`,
      method: "GET",
    });
  },
  updateTxn(id, customer_id, status, remarks) {
    return request({
      url: `${PaymentbaseUrl}/update/txn-status?transaction_id=${id}&customer_id=${customer_id}&txn_status=${status}&remarks=${remarks}`,
      method: "PUT",
    });
  },
  updateSender(customer_id, data) {
    return request({
      url: `${PaymentbaseUrl}/update-sender-details?customer_id=${customer_id}`,
      method: "PUT",
      data,
    });
  },
  updateReceiverDetails(receiver_id, data) {
    return request({
      url: `${PaymentbaseUrl}/update-receiver-details?receiver_id=${receiver_id}`,
      method: "PUT",
      data,
    });
  },
  updateTxnDetails(params, data) {
    return request({
      url: `${PaymentbaseUrl}/update-txn-info-details`,
      method: "PUT",
      params:params,
      data,
    });
  },
  updateStatusPinnumber({
    pin_number,
    txn_status,
    txn_stage = "",
    remarks = "",
  }) {
    return request({
      url: `${PaymentbaseUrl}/update/txn-status-pinnumber`,
      method: "PUT",
      params: {
        pin_number,
        txn_status,
        txn_stage,
        remarks,
      },
    });
  },
  updateTxnUpdateVersion(params) {
    return request({
      url: `${PaymentbaseUrl}/update-txn-details`,
      method: "PUT",
      params,
    });
  },
  postRemarks(params) {
    return request({
      url: `${PaymentbaseUrl}/enable/txn/remarks`,
      method: "PUT",
      params,
    });
  },

  getHoldTxnsByDate(from_date, to_from) {
    return request({
      url: `${PaymentbaseUrl}/get-hold-txns-by-date?from_date=${from_date}&to_date=${to_from}`,
      method: "POST",
    });
  },

  //---------------------------------PUSHED TRANSACTIONS-----------------------------------//

  getPushedTxnsByDate(params) {
    return request({
      url: `${PaymentbaseUrl}/get-non-pushed-txns-by-date`,
      method: "POST",
      params: params,
    });
  },
  getAllPushedTxns(data) {
    return request({
      url: `${PaymentbaseUrl}/get-non-pushed-txns?today=${data}`,
      method: "POST",
    });
  },
  downloadLogsData(pin) {
    return request({
      url: `${PaymentbaseUrl}/download-txn-logs?pinumber=${pin}`,
      method: "GET",
    });
  },
  getmmQuotation(params) {
    return request({
      url: `${PartnerbaseUrl}/make-mm-quotation`,
      method: "GET",
      params: params,
    });
  },
  pushTransPinNumber(pinNumber) {
    return request({
      url: `${PartnerbaseUrl}/push-transaction-by-pin?pin_number=${pinNumber}`,
      method: "GET",
    });
  },
  pushTrans(selectedTxnId, remarks) {
    return request({
      url: `${PartnerbaseUrl}/push-transaction-by-pin?pin_number=${selectedTxnId}&remarks=${remarks}`,
      method: "GET",
    });
  },
  //-----------------get-txn-note---------------------//
  getTxnNote(ref_number) {
    return request({
      url: `${PaymentbaseUrl}/get-txn-note-by-pin?reference_no=${ref_number}`,
      method: "GET",
    });
  },

  //----------------Domestic Payments---------------------//
  getBalanceHistory(params) {
    return request({
      url: `${domesticbaseUrl}/transaction-summery`,
      method: "get",
      params: params,
    });
  },
  getBalanceSummary(params) {
    return request({
      url: `${PartnerbaseUrl}/get-hc-balance`,
      method: "get",
      params: params,
    });
  },
  getPayInSummary(params) {
    return request({
      url: `${domesticbaseUrl}/payin-summery`,
      method: "get",
      params: params,
    });
  },
  getPayOutSummary(params) {
    return request({
      url: `${domesticbaseUrl}/payout-summery`,
      method: "get",
      params: params,
    });
  },
  getPayInTxn(id) {
    return request({
      url: `${domesticbaseUrl}/get-payin-txn-details?txn_id=${id}`,
      method: "get",
    });
  },
  getPayOutTxn(id) {
    return request({
      url: `${domesticbaseUrl}/get-payout-txn-details?txn_id=${id}`,
      method: "get",
    });
  },
};
